import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { TextField, Autocomplete, Box } from '@mui/material';
import { useStyles } from './styles';
import useSelectedOption from '../../../../utils/hooks/useSelectedOption';
import getErrorMessage from '../../../../utils/helper_functions/getErrorMessage';
import getIsError from '../../../../utils/helper_functions/getIsError';
import { inputDataCustom } from '../../../../utils/custom_prop_types/customPropTypes';
import Loader from '../../../commons/Loader';

export default function PostSection({
  loader,
  posts,
  handlePostSelectChange,
  postsInput,
  setPostsInput,
  inputData,
  validation,
}) {
  const [postsArray, setPostsArray] = useState([]);
  const classes = useStyles();
  const selectedOption = useSelectedOption(postsArray, inputData.postIRI);

  useEffect(() => {
    setPostsArray([]);

    posts['hydra:member']?.forEach((product) => (
      setPostsArray((prevState) => [...prevState,
        {
          description: product.description,
          compare: product['@id'],
          iri: product['@id'],
          value: product.productGroup.number,
        }])
    ));
  }, [posts]);

  return (
    <Box className={classes.inputWrapper}>
      <Autocomplete
        disabled={loader.posts}
        autoHighlight
        className={classes.posts}
        getOptionLabel={(option) => option.description}
        disableClearable
        options={postsArray}
        value={selectedOption}
        inputValue={postsInput}
        onChange={(_, value) => handlePostSelectChange(value)}
        renderInput={(params) => (
          <TextField
            // eslint-disable-next-line react/jsx-props-no-spreading
            {...params}
            label="Posts"
            color="secondary"
            variant="standard"
            error={getIsError('post', validation.form)}
            helperText={getErrorMessage('post', validation.form)}
            onChange={(event) => setPostsInput(event.target.value)}
          />
        )}
      />
      <Loader target="posts" offsetRight={48} size={18} centeredY />
    </Box>
  );
}

PostSection.propTypes = {
  loader: PropTypes.objectOf(PropTypes.bool).isRequired,
  fetchProductsBySection: PropTypes.func.isRequired,
  inputData: inputDataCustom.isRequired,
  posts: PropTypes.objectOf(PropTypes.any).isRequired,
  handlePostSelectChange: PropTypes.func.isRequired,
  postsInput: PropTypes.string.isRequired,
  setPostsInput: PropTypes.func.isRequired,
  setInputDataToSend: PropTypes.func.isRequired,
  validation: PropTypes.shape({
    form: PropTypes.arrayOf(PropTypes.any),
  }).isRequired,
};
